// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"af483756","45":"2bf01a15","55":"6ef5bda4","147":"d87c7c32","171":"3cf8178a","374":"df8961a5","444":"11c69805","453":"e389122d","466":"05c5ef46","769":"a1f53227","780":"a499dea8"}[chunkId] + ".chunk.js";
};